<template>
  <div
    v-if="badge"
    :class="`${badge.colorClass} tw-rounded-md tw-font-medium tw-px-1 tw-text-white`"
  >
    {{ badge.text }}
  </div>
</template>

<script setup lang="ts">
import { useBadge } from "./useBadge";

const { badge } = useBadge();
</script>
